import { render, staticRenderFns } from "./formLinkItem.vue?vue&type=template&id=7b5ec919&"
import script from "./formLinkItem.vue?vue&type=script&lang=js&"
export * from "./formLinkItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports